export default __webpack_public_path__ + "static/media/sun.33fb29f6.svg";